export default __webpack_public_path__ + "static/media/CarImages.SedonaGallery2.91daa297.jpg";